import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../../components/PublicLayout';
import Seo from '../../components/Seo';
import { LEGAL, COMPANY } from './legalContent';

const C = {
  green: '#1B5C3A', greenDark: '#0F3D26', gold: '#F5A623',
  ink: '#1A1A1A', muted: '#374151', soft: '#6B7280',
  border: '#E5E7EB', cream: '#FAF8F3', greenLight: '#E8F5EE', white: '#FFFFFF',
};
const F = { body: "'Plus Jakarta Sans', system-ui, sans-serif" };

// Footer cross-links between the legal docs.
const NAV = [
  ['Terms of Use', '/terms'], ['Privacy Policy', '/privacy'], ['Disclaimer', '/disclaimer'],
  ['Buyer & Seller Responsibilities', '/responsibilities'], ['Payment & Refund', '/refund-policy'],
  ['Grievance Redressal', '/grievance'],
];

function Block({ b }) {
  if (b.h) return <h2 style={{ fontFamily: F.body, fontSize: 18, fontWeight: 700, color: C.greenDark, margin: '28px 0 10px' }}>{b.h}</h2>;
  if (b.p) return <p style={{ fontFamily: F.body, fontSize: 15, color: C.muted, lineHeight: 1.8, margin: '0 0 12px' }}>{b.p}</p>;
  if (b.ul) return (
    <ul style={{ margin: '0 0 14px', paddingLeft: 22 }}>
      {b.ul.map((it, i) => (
        <li key={i} style={{ fontFamily: F.body, fontSize: 15, color: C.muted, lineHeight: 1.75, marginBottom: 7 }}>{it}</li>
      ))}
    </ul>
  );
  return null;
}

export default function LegalPage({ doc }) {
  const d = LEGAL[doc];
  useEffect(() => { window.scrollTo(0, 0); }, [doc]);
  if (!d) return null;

  return (
    <PublicLayout>
      <Seo title={`${d.title} | Kanjusee`} description={d.seo} canonical={d.path} />
      <div style={{ background: C.cream, minHeight: '60vh', paddingBottom: 64 }}>
        {/* Header band */}
        <div style={{ background: `linear-gradient(140deg, ${C.greenDark}, ${C.green})`, padding: '52px 24px 44px' }}>
          <div style={{ maxWidth: 880, margin: '0 auto' }}>
            <div style={{ fontFamily: F.body, fontSize: 12, fontWeight: 800, letterSpacing: 2.5, color: C.gold, textTransform: 'uppercase', marginBottom: 10 }}>Legal</div>
            <h1 style={{ fontFamily: F.body, fontSize: 34, fontWeight: 800, color: C.white, margin: 0, lineHeight: 1.2 }}>{d.title}</h1>
            <div style={{ fontFamily: F.body, color: 'rgba(255,255,255,0.78)', fontSize: 14, marginTop: 12 }}>
              Last updated: {COMPANY.updated} &nbsp;·&nbsp; Operated by {COMPANY.legalName}
            </div>
          </div>
        </div>

        {/* Body card */}
        <div style={{ maxWidth: 880, margin: '-22px auto 0', padding: '0 24px' }}>
          <div style={{ background: C.white, borderRadius: 16, padding: '40px 34px', boxShadow: '0 6px 28px rgba(0,0,0,0.06)', border: `1px solid ${C.border}` }}>
            {d.blocks.map((b, i) => <Block key={i} b={b} />)}

            {/* Company contact card */}
            <div style={{ marginTop: 38, padding: '20px 22px', background: C.greenLight, borderRadius: 12, border: `1px solid ${C.border}` }}>
              <div style={{ fontFamily: F.body, fontWeight: 800, color: C.green, marginBottom: 6 }}>{COMPANY.legalName}</div>
              <div style={{ fontFamily: F.body, color: C.muted, fontSize: 14, lineHeight: 1.75 }}>
                Operator of {COMPANY.site}<br />
                {COMPANY.address}<br />
                Phone: {COMPANY.phone} &nbsp;·&nbsp; Email: <a href={`mailto:${COMPANY.email}`} style={{ color: C.green, fontWeight: 600 }}>{COMPANY.email}</a>
              </div>
            </div>
            <div style={{ marginTop: 16, fontFamily: F.body, fontSize: 12, color: C.soft, fontStyle: 'italic' }}>
              These documents are provided for general information and do not by themselves constitute legal advice.
            </div>
          </div>

          {/* Cross-links to other legal docs */}
          <div style={{ marginTop: 28, display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
            {NAV.map(([label, path]) => (
              <Link key={path} to={path} style={{
                fontFamily: F.body, fontSize: 13, fontWeight: 600, textDecoration: 'none',
                padding: '8px 14px', borderRadius: 9,
                background: path === d.path ? C.green : C.white,
                color: path === d.path ? C.white : C.muted,
                border: `1px solid ${path === d.path ? C.green : C.border}`,
              }}>{label}</Link>
            ))}
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
